/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_SubmitInputs */

const vi_trip_force_end_submit = /** @type {(inputs: Trip_Force_End_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc chuyến`)
};

/**

* @param {Trip_Force_End_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_submit = /** @type {((inputs?: Trip_Force_End_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_submit(inputs)
});